<template>
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-header pl-3 pr-3">
        <a class="navbar-brand" href="#/campaignList"><img alt="Global Overview" src="../assets/images/logo.png"/></a>
        <!--<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>-->
        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul class="navbar-nav mr-auto ml-4 mt-2 mt-lg-0">
				<li class="nav-item pr-1 pl-1" :class=" currentPage == 'productList' || currentPage == 'addEditProduct' || currentPage == 'addNewProduct' ? 'active' : ''">
					<a class="nav-link" @click="navigateToProducts" >Products</a>
				</li>
				<li class="nav-item pr-1 pl-1" :class="currentPage == 'campaignGroupList' || currentRoute.campGrpId  ? 'active' : ''">
					<a class="nav-link" @click="navigateToCampaignGroup" >Campaign Groups</a>
				</li>
                <li class="nav-item pr-1 pl-1" :class="(currentPage == 'addToCampaign' || currentPage == 'campaignList' || currentPage == 'campaignListPerGroup' ||  currentPage == 'addEditCampaign' || currentPage == 'CampaignDetail' || currentPage == 'addNewCampaign' || currentPage == 'KeywordDetail' || currentRoute.campId) ? 'active' : ''">
                    <a class="nav-link"  @click="navigateToCampaign" ><span>Campaigns</span></a>
                    <!-- <span><i class="fa fa-chevron-left"></i></span> -->
                </li>
                <li class="nav-item pr-1 pl-1" :class="currentPage == 'notification' ? 'active' : ''">
                    <a class="nav-link" @click="navigateToNotificationList" >Notifications</a>
                </li>

                <li class="nav-item pr-1 pl-1" :class="currentPage == 'asinScraper' || currentPage == 'asinScraperAddForm' ? 'active' : ''">
                    <a class="nav-link" @click="navigateToProductScraper" >ASIN Scraper</a>
                </li>
				<li class="nav-item pr-1 pl-1" :class="currentPage == 'Automation2' || currentPage == 'addGuardrail' ? 'active' : ''">
					<a class="nav-link" @click="navigateToAutomation2" >Guardrails</a>
				</li>
				<li class="nav-item pr-1 pl-1" :class="currentPage == 'tableau3'  ? 'active' : ''">
					<a class="nav-link" @click="navigateToTableau" >Executive Reporting</a>
				</li>
				<li class="nav-item pr-1 pl-1" :class="currentPage == 'accounts' || currentPage == 'addVendor' || currentPage == 'accountDetails' || currentPage == 'editBrand' || currentPage == '/accountDetails/profile' ? 'active' : ''">
					<a class="nav-link" @click="navigateToAccounts" >Account Management</a>
				</li>

				<!-- <li class="nav-item pr-1 pl-1" :class="currentPage == 'salesList' ? 'active' : ''">
					<a class="nav-link" @click="navigateToSales">Sales Diagnostic</a>
				</li> -->
            </ul>
        </div>
        <div class="dropdown ml-auto mr-3 user-drop-down-wrap" v-if="currentPage != 'CampaignDetail'">
			<a href="javascript:void(0)" class="dropdown-toggle user-settings" data-toggle="dropdown" id="loggedInUserName">Account Name</a>
			<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="left: -70px;">
				<!-- <a class="dropdown-item" href="campaign.html">Campaigns</a> <a
					class="dropdown-item" href="alert.html">Notifications</a> <a
					class="dropdown-item" href="asin.html">ASIN Scraper</a>  -->
					<a class="dropdown-item" @click="navigateToReleaseNotes" style="cursor:pointer;">Resources & Updates</a>
					<a class="dropdown-item" @click="navigateToTemplates" style="cursor:pointer;">Templates</a>
					<!-- <a class="dropdown-item" @click="navigateToMap" style="cursor:pointer;">Mapping</a> -->
					<a class="dropdown-item" @click="navigateToLogout" style="cursor:pointer;">Log Out</a>
			</div>
		</div>
        <div class="" style="heigth:200px;"></div>
    </nav>
</template>

<script>
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

export default {
    name: 'MainHeader',
    data() {
        return {

        }
    },
    computed: {
        selectedPage: {
            set(val) {
                this.$store.state.selectedPage = val
            },
            get() {
                return this.$store.state.selectedPage
            }
        },
        currentPage() {
            return this.$route.name
        },
		currentRoute(){
			return this.$route.params
		}
    },
    mounted() {
        $("#loggedInUserName").text(this.getName());
    },
    methods: {
        resetAdvanceFilter(){
			this.$store.state.campaign.advanceFilter = {}
			this.$store.state.accountsFilter = []
			this.$store.state.accounts.advanceFilter = {}
			this.$store.state.campaignsFilter = []
			this.$store.state.productAdvanceFilter = []
            this.$store.state.product.productAdvanceFilter = {}
            this.$store.state.automation.advanceFilterAutomation = {}
            this.$store.state.automationFilter = []
		},
        resetCampData(){
            this.$store.state.selectedVendorFilter = "";
            this.$store.state.selectedBrandProfle = ""
            this.$store.state.selectedCampaignGroupFilter = ''
            this.$store.state.selectedTag = ''
            this.$store.state.currentPageNumber = 1
            this.$store.state.searchFilterString = ''
            this.$store.state.selectedSortOrder = {field: "name", order: "asc"}
            this.$store.state.campaign.campaignToAddToGroupList = [];
            this.$store.state.campaign.actionSelectionControl = false
        },
        resetCampGrpData(){
            this.$store.state.campaign.actionSelectioncampaignGroupControl = false
            this.$store.state.campaign.campaignGroupSelectedList = []
            this.$store.state.selectedBrandProfle = ""
            this.$store.state.selectedVendorFilter = ""
            this.$store.state.currentPageNumber = 1
            this.$store.state.searchFilterString = ''
            this.$store.state.selectedCampaignGroupFilter = ''
            this.$store.state.selectedSortOrder = {field: "name", order: "asc"}
        },
        resetProdData(){
            this.$store.state.product.selectedProducts = []
            this.$store.state.product.actionSelectionControl = false
            this.$store.state.searchFilterString = ''
            this.$store.state.selectedVendorProduct = ''
            this.$store.state.selectedBrandProduct= ''
            this.$store.state.currentPageNumber = 1
            this.$store.state.selectedSortOrder = {field: "product_title", order: "asc"}
        },
        resetAutomationData(){
            this.$store.state.currentPageNumber = 1
            this.$store.state.automation.owner = 'Me'
            this.$store.state.automation.target='All'
            this.$store.state.automation.subTarget = null
            this.$store.state.automation.subTargetValue = null

        },
        resetAccountsData(){
            this.$store.state.searchFilterString = ''
            this.$store.state.currentPageNumber = 1
            this.$store.state.selectedSortOrder = {
					field:'date_created',
					order:'desc'
					}
        },
        resetNotifications(){
            this.$store.state.currentPageNumber = 1
            this.$store.state.selectedLastXDays = ''
            this.$store.state.selectedVendorNotification = ""
            this.$store.state.searchFilterString = ''
            this.$store.state.selectedSortOrder = {
				field:'createdon',
				order:'desc'
			}
        },
        resetAsinData(){
            this.$store.state.selectedBrandProduct = ""
            this.$store.state.selectedVendorFilter = ''
            this.$store.state.product.actionSelectionControl = false;
			this.$store.state.product.selectedProducts = []
            this.$store.state.currentPageNumber = 1
            this.$store.state.searchFilterString = ''
            this.$store.state.selectedSortOrder = {
                field:'updated_on',
			    order:'desc'
            }
        },
        getName() {
            const getSession = JSON.parse(window.localStorage.getItem('session'));
		    return getSession.user ? getSession.user.name : getSession.name;
        },
        testLink() {
        },
        navigateToProducts() {
            if(this.$route.name != 'productList'){
                this.resetProdData()
                this.resetAdvanceFilter()
            }
            this.$router.push({path:'/productList'})
        },
        navigateToCampaignGroup() {
            console.log(this.$route)
            if(this.$route.name != 'campaignGroupList') {
                this.resetCampGrpData()
                this.selectedPage = 'CampaignGroup'
                this.$router.push({path:'/campaignGroupList'})
            }
        },
        navigateToCampaign() {
            console.log(this.$route)
            if(this.$route.name != 'campaignList'){
                this.resetCampData()
                this.resetAdvanceFilter()
            }
            this.$router.push({path:'/campaignList'})
        },
        navigateToAddProduct() {
            this.$router.push({path:'/addEditProduct'})
        },
        navigateToNotificationList() {
            if(this.$route.name != 'notification'){
                this.resetNotifications()
            }
            this.$router.push({path:'/notification'})
        },
        navigateToProductScraper() {
            if(this.$route.name !='asinScraper'){
                this.resetAsinData()
            }
            this.$router.push({path:'/asinScraper'})
        },
		navigateToAutomation2() {
            if(this.$route.name != 'Automation2') {
                this.resetAutomationData()
                this.resetAdvanceFilter()
            }
			this.$router.push({path:'/automation2'})
		},
		navigateToTableau(){
			
			this.$router.push({path:'/tableau3'})
		},
		navigateToAccounts(){
            if(this.$route.name != 'accounts') {
                this.resetAccountsData()
                this.resetAdvanceFilter()
            }
			this.$router.push({path:'/accounts'})
		},
		navigateToSales(){
			this.$router.push({path:'/salesList'})
		},
		navigateToMap(){
			this.$router.push({path:'/mapping'})
		},
        navigateToLogout(){
			this.loguserOutFromCognito();
			this.$store.commit('clearSessionData');
			this.$router.push({path:'/login'})
        },
		navigateToReleaseNotes(){
			this.$store.state.release.pathBeforeReleaseNote = this.$route.fullPath;
			this.$router.push({path:'/releaseNotes'})
		},
		navigateToTemplates(){
			this.$store.state.release.pathBeforeReleaseNote = this.$route.fullPath;
			this.$router.push({path:'/template'})
		},
		loguserOutFromCognito(){
			//

			var data = {
				UserPoolId : 'us-east-1_KPh2ycnq4', // Your user pool id here
				ClientId : '1qe6ml4g9dh4c1sl5j99k8965j' // Your client id here
			};

			var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);

			var userData = {
				  Username : JSON.parse(window.localStorage.getItem('session')).username, //'kjoshi@contata.com',
				  Pool : userPool
			  };
			var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
			cognitoUser.signOut()
			sessionStorage.clear();
			localStorage.clear();

		}
    }
}
</script>

<style lang="scss">
    .navbar {
        padding-top:0 !important;
        padding-bottom: 0 !important;
        line-height: 30px;
    }
    .nav-item:hover {
        /* background: #fff; */
    }
    .nav-item:hover {
        a {
            background: #fff;
            color: variables.$tert-blue !important;
            -webkit-transition: all 0.4s ease;
            -moz-transition: all 0.4s ease;
            -o-transition: all 0.4s ease;
            -ms-transition: all 0.4s ease;
        }
    }
	.nav-item{
		line-height: 25px;
    	padding-top: 10px;
	}
	.navbar-brand {
        img{
		    height: 35px;
        }
	}
	.nav-item a {
        color: #fff !important;
		cursor: pointer;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
    }
    .active a {
        background: #fff;
        color: variables.$tert-blue !important;
        font-weight:550 !important;
        /* font-size: 18px; */
    }
	 a:focus{
		outline-color: none !important;
		outline-style: none
	}

</style>
